/* N1 · Rendimiento por palma (natural / artificial / mojado).
   Se escribe una sola vez por palma y cada guante recibe el suyo según la palma que monta.
   Aparece en el comparador (página y popup del catálogo) y en la escala de palmas.
   07/10/2026 (multidioma fase 2, lote 3b): los textos salen de window.N1T (claves n1.perf.*); el español de aquí es solo respaldo. */
(function(){
if(window.N1Perf)return;window.N1Perf=1;
var T=function(k,d){var v=window.N1T&&window.N1T[k];return (typeof v==='string'&&v&&!/translation missing/i.test(v))?v:d},F=function(s,o){return String(s).replace(/\{(\w+)\}/g,function(m,k){return o&&o[k]!=null?o[k]:m})};

var P={
 ugt:{n:'máxima performance y excelente vida útil',a:'la misma performance que en natural, con durabilidad inferior por la abrasión',m:'excelente rendimiento'},
 contact:{n:'máxima performance y amortiguación',a:'la misma performance que en natural, con durabilidad inferior por la abrasión',m:'excelente rendimiento'},
 giga:{n:'excelente agarre',a:'el mismo agarre, con durabilidad inferior por la abrasión',m:'excelente rendimiento en campo mojado'},
 duo:{n:'excelente agarre',a:'el mismo agarre, con durabilidad inferior por la abrasión',m:'muy buen rendimiento'},
 ssgpro:{n:'excelente agarre',a:'pensada para césped sintético, con una durabilidad excelente',m:'buen rendimiento'},
 ssg:{n:'buen agarre para el día a día',a:'pensada para césped sintético, con una durabilidad excelente',m:'rendimiento aceptable'},
 dura:{n:'agarre pensado para empezar a jugar',a:'la máxima durabilidad de la gama, para pistas y superficies abrasivas',m:'su mejor rendimiento es en seco'}
};
function fam(palma){
  var p=(palma||'').toLowerCase();
  if(!p)return null;
  if(p.indexOf('ugt')>-1)return 'ugt';
  if(p.indexOf('contact')>-1)return 'contact';
  if(p.indexOf('duo')>-1)return 'duo';
  if(p.indexOf('ssg pro')>-1)return 'ssgpro';
  if(p.indexOf('giga')>-1)return 'giga';
  if(p.indexOf('ssg')>-1)return 'ssg';
  if(p.indexOf('duratech')>-1||p.indexOf('sintético')>-1)return 'dura';
  return null;
}
function loc(f){var x=P[f];return x?{n:T('n1.perf.'+f+'_n',x.n),a:T('n1.perf.'+f+'_a',x.a),m:T('n1.perf.'+f+'_m',x.m)}:null}
window.N1Perf={map:P,fam:fam,text:function(palma){var f=fam(palma);return f?loc(f):null}};

var css=''
+'.n1-perf{display:grid;gap:.45rem;margin:.2rem 0 0}'
+'.n1-perf .r{display:grid;grid-template-columns:96px 1fr;gap:.6rem;align-items:baseline;font-size:.8rem;line-height:1.45}'
+'.n1-perf .r b{font-size:.58rem;letter-spacing:.12em;text-transform:uppercase;font-weight:800;color:#e4ee05}'
+'.n1-perf .r span{color:rgb(var(--text-color,255 255 255) / .8)}'
+'#n1k-cpop .n1-perf .r span{color:rgba(255,255,255,.82)}'
/* 07/10/2026: dentro de la escala de palmas (.tier b) y del comparador (.vals div) las etiquetas heredaban estilos ajenos y no cabían */
+'.n1-perf .r b{display:block!important;font-family:var(--text-font-family)!important;font-style:normal!important;font-size:.58rem!important;line-height:1.3!important;letter-spacing:.12em!important;text-transform:uppercase!important;margin:0!important;white-space:nowrap}'
+'@media(min-width:521px){.n1-perf .r{grid-template-columns:minmax(84px,max-content) 1fr!important}}'
+'.n1-compare .vals .n1-perf div,.n1-compare .vals .n1-perf{padding:0!important;border:0!important;margin:0!important;background:none!important}'
+'.n1-compare .vals .n1-perf{margin-top:.2rem!important}'
+'@media(max-width:520px){.n1-perf .r{grid-template-columns:1fr;gap:.1rem}}';
var st=document.createElement('style');st.textContent=css;(document.head||document.documentElement).appendChild(st);

function block(t){
  return '<div class="n1-perf">'
   +'<div class="r"><b>'+T('n1.perf.natural','Natural')+'</b><span>'+t.n+'</span></div>'
   +'<div class="r"><b>'+T('n1.perf.artificial','Artificial')+'</b><span>'+t.a+'</span></div>'
   +'<div class="r"><b>'+T('n1.perf.wet','Mojado')+'</b><span>'+t.m+'</span></div>'
   +'</div>';
}
/* ---- escala de palmas: una línea por nivel bajo las barras ---- */
function scale(){
  document.querySelectorAll('.n1-latex .tier').forEach(function(t){
    if(t.dataset.n1perf)return;
    var b=t.querySelector('b');if(!b)return;
    var f=fam(b.textContent);if(!f)return;
    t.dataset.n1perf=1;
    var bars=t.querySelector('.bars');if(!bars)return;
    var d=document.createElement('div');
    d.className='who';d.style.paddingTop='.9rem';
    d.innerHTML='<em>'+T('n1.perf.title','Rendimiento')+'</em>'+block(loc(f));
    bars.parentNode.insertBefore(d,bars.nextSibling);
  });
}
function run(){try{scale()}catch(e){}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
addEventListener('load',run);setTimeout(run,900);setTimeout(run,2200);
})();
